// Migrated
// Translated
<template>
  <div>
    <div
      :id="`container-${tableId}`"
      ref="tripCalendar"
      class="trip-calendar rounded-lg lg:pb-4"
    >
      <div
        id="trip-filter-bar"
        class="flex flex-col print-hidden z-[3] relative"
      >
        <div
          v-if="filterCount > 0"
          class="flex flex-col justify-start print-hidden z-[3] relative rounded-t-lg pt-4"
          :class="{ 'mt-6': mainTab }"
        >
          <div
            v-if="activeDeparturesView !== 'calendar' && months.length > 2"
            class="mr-auto flex flex-wrap mb-8 order-1 -mx-2 w-full md:w-auto"
            :class="{ 'w-12/12': filterCount > 2 }"
          >
            <div
              v-for="(month, index) in months"
              :key="index"
              class="w-1/3 px-2 sm:w-1/4 md:w-auto whitespace-nowrap"
            >
              <button
                class="rounded-3xl py-1 md:py-2 px-4 font-normal float-left mr-3 mb-4 capitalize font-secondary w-full"
                type="button"
                v-bind="monthButtonAttributes(month)"
                @click="selectMonth(month)"
              >
                {{ month }}
              </button>
            </div>
          </div>

          <div class="flex flex-col lg:flex-row order-2 md:-my-6 flex-wrap md:-mx-4 print-hidden">
            <div class="flex flex-col md:flex-row flex-1 md:space-x-8 space-y-7 md:space-y-0 md:py-6 md:px-4">
              <LazyCalendarFilterAirport
                v-if="flightTrip"
                ref="airportSelect"
                :has-airport-all-option="!filters.defaultAirport"
                :airports="airports"
                :prefilled-airport-iata="selectedAvailableAirport"
                @update="selectAirport"
              />

              <LazyCalendarFilterDropdown
                v-if="hotels.length"
                ref="hotelSelect"
                :value="currentHotel"
                :is-active="filters.selectedHotel"
                :label="$t('calendar.chooseHotel')"
                label-i18n="calendar.chooseHotel"
                icon="hotel"
              >
                <div class="w-full py-2">
                  <button
                    class="dropdown-item !flex flex-row items-center !justify-start"
                    type="button"
                    data-i18n="allHotels"
                    :class="{ 'px-2': someHotelsAreRecommended }"
                    @click="selectHotel(null)"
                  >
                    <div
                      v-if="someHotelsAreRecommended"
                      class="w-[2rem] mr-1"
                    />
                    <span>
                      {{ $t('allHotels') }}
                    </span>
                  </button>
                  <button
                    v-for="hotel in hotels"
                    :key="hotel?.id"
                    class="dropdown-item !flex flex-row items-center !justify-start"
                    type="button"
                    :class="{ 'px-2': someHotelsAreRecommended }"
                    @click="selectHotel(hotel?.name)"
                  >
                    <div
                      v-if="someHotelsAreRecommended"
                      class="c-orange w-[2rem] mr-1"
                    >
                      <StarByLocale
                        v-if="hotel?.recommended && !allHotelsAreRecommended"
                        :size="16"
                      />
                    </div>
                    <span>
                      {{ hotel?.name }}
                    </span>
                  </button>
                </div>
              </LazyCalendarFilterDropdown>

              <LazyCalendarFilterDropdown
                v-if="triplengths.length > 1"
                ref="triplengthsSelect"
                :value="currentTriplength"
                :is-active="filters.selectedHotel"
                :label="$t('calendar.chooseTripLength')"
                label-i18n="calendar.chooseTripLength"
              >
                <template #icon>
                  <i-rotate-right-one />
                </template>

                <div class="w-full py-2">
                  <button
                    class="dropdown-item font-normal text-base normal-case"
                    type="button"
                    data-i18n="allTriplengths"
                    @click="filters.selectedTriplength = null"
                  >
                    {{ $t('allTriplengths') }}
                  </button>
                  <button
                    v-for="(key, i) in triplengths"
                    :key="i"
                    class="dropdown-item"
                    type="button"
                    @click="filters.selectedTriplength = key"
                  >
                    <span>
                      {{ key }}
                    </span>
                  </button>
                </div>
              </LazyCalendarFilterDropdown>
            </div>

            <CalendarFilterButton
              v-if="hasActiveFilters"
              class="underline text-blue-800 font-semibold mt-4 md:hidden bg-white p-2 rounded-lg"
              :label="$t('calendar.tooManyFiltersLink')"
              label-i18n="calendar.tooManyFiltersLink"
              icon="rotate-left"
              icon-side="right"
              @click="resetFilters(false)"
            />

            <hr class="bg-gray-500/25 h-0.5 my-6 md:hidden" />

            <div class="flex flex-col md:flex-row md:items-center font-secondary md:space-x-8 md:ml-auto space-y-6 md:space-y-0 mb-8 max-md:w-full md:py-6 md:px-4">
              <CalendarFilterButton
                :muted="activeDeparturesView === 'table'"
                :class="activeDeparturesView === 'table'
                  ? 'pointer-events-none'
                  : 'text-blue-800 underline font-semibold'
                "
                :label="$t(activeDeparturesView === 'table' ? 'calendar.viewingCalendarlist' : 'calendar.viewCalendarlist')"
                :label-i18n="activeDeparturesView === 'table' ? 'calendar.viewingCalendarlist' : 'calendar.viewCalendarlist'"
                icon="list-ul"
                class="bg-white p-2 rounded-lg md:bg-transparent md:p-0 md:rounded-none"
                @click="changeActiveDeparturesView('table')"
              />
              <CalendarFilterButton
                :muted="activeDeparturesView === 'calendar'"
                :class="activeDeparturesView === 'calendar'
                  ? 'pointer-events-none'
                  : 'text-blue-800 underline font-semibold'
                "
                :label="$t(activeDeparturesView === 'calendar' ? 'calendar.viewingCalendar' : 'calendar.viewCalendar')"
                :label-i18n="activeDeparturesView === 'calendar' ? 'calendar.viewingCalendar' : 'calendar.viewCalendar'"
                icon="calendar"
                class="bg-white p-2 rounded-lg md:bg-transparent md:p-0 md:rounded-none"
                @click="changeActiveDeparturesView('calendar')"
              />
            </div>
          </div>
        </div>

        <div
          v-if="hasActiveFilters || shouldShowSoldoutFilter || getMemberActiveSingle"
          class="flex justify-between grow mb-3 md:py-0 mt-4 order-1 md:order-3 print-hidden"
        >
          <CalendarFilterButton
            v-if="hasActiveFilters"
            class="underline text-blue-800 font-semibold hidden md:flex bg-white p-2 rounded-lg"
            :label="$t('calendar.tooManyFiltersLink')"
            label-i18n="calendar.tooManyFiltersLink"
            icon="rotate-left"
            @click="resetFilters(false)"
          />

          <div class="flex flex-col items-end grow space-y-2 max-md:mb-8 max-md:-mt-4 justify-center">
            <div
              v-if="shouldShowSoldoutFilter"
              :class="{
                'pointer-events-none': !filters.overridingHideSoldout
              }"
              class="flex items-center max-md:justify-between max-md:w-full font-secondary bg-white p-2 rounded-lg md:bg-transparent md:p-0 md:rounded-none text-base font-semibold text-blue-800 cursor-pointer"
              @click="filters.hideSoldout = !filters.hideSoldout"
            >
              <span
                v-if="!filters.hideSoldout || filters.overridingHideSoldout"
                data-i18n="calendar.hideSoldout"
              >{{ $t('calendar.hideSoldout') }}</span>
              <span
                v-else
                data-i18n="calendar.hidingSoldout"
              >{{ $t('calendar.hidingSoldout') }}</span>

              <ToggleSwitch
                v-model="filters.hideSoldout"
                class="ml-3"
                :disabled="filters.overridingHideSoldout"
              />
            </div>

            <div
              v-if="getMemberActiveSingle"
              class="flex items-center max-md:justify-between max-md:w-full font-secondary bg-white p-2 rounded-lg md:bg-transparent md:p-0 md:rounded-none text-base font-semibold text-blue-800 cursor-pointer"
            >
              <span
                v-if="!filters.hideAllNotSingle"
                data-i18n="memberShowOnlyCompanions"
              >{{ $t('memberShowOnlyCompanions') }}</span>
              <span
                v-else
                data-i18n="memberShowingOnlyCompanions"
              >{{ $t('memberShowingOnlyCompanions') }}</span>

              <ToggleSwitch
                v-model="filters.hideAllNotSingle"
                class="ml-3"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="activeDeparturesView === 'table'"
        class="print:hidden"
      >
        <InfiniteScroll
          :scolling-offset="200"
          :interval="60"
          :disabled="showRows >= filteredTrips.length"
          :scroll-back-element="`#container-${tableId}`"
          offset-to-element
          @fetch="showMoreRows"
        >
          <template #content>
            <DeparturesTable
              ref="table"
              class="max-lg:-mx-4"
              :show-airport="flightTrip"
              :loading="loading"
              :show-seats-left="showSeatsLeft"
              :tour-guide-exists="tourGuideExists"
              :trips="visibleRows"
              :show-info="!flightTrip"
              is-book-departures
              mark-row-status
              mobile-layout="date-first"
              @open-info="openInfo"
              @open-waitinglist="openWaitinglist"
              @marking="markingMonth"
            />
          </template>
          <template #loading>
            <Loading v-if="showRows < filteredTrips.length" />
          </template>
          <template #scrollBackLabel>
            <span data-i18n="scrollToDepartureTableTopLabel">
              {{ $t('scrollToDepartureTableTopLabel') }}
            </span>
          </template>
        </InfiniteScroll>
      </div>

      <div
        v-if="activeDeparturesView === 'table'"
        class="hidden print-block"
      >
        <DeparturesTable
          :show-airport="flightTrip"
          :loading="false"
          :show-seats-left="false"
          :tour-guide-exists="tourGuideExists"
          :trips="filteredTripsForPrint"
          :show-info="false"
          is-book-departures
          mark-row-status
        />
      </div>

      <div
        v-else-if="activeDeparturesView === 'calendar'"
        class="print-hidden"
      >
        <Suspense>
          <LazyDeparturesCalendar
            ref="calendar"
            :trips="filteredTrips"
            :override-airport-name="isOverridingAirport ? selectedAvailableAirportName : null"
            :multi-calendar-breakpoint="mainTab ? 1500 : getTailwindBreakpointsPx().lg"
            @open-waitinglist="openWaitinglist"
          />

          <template #fallback>
            <b-skeleton />
          </template>
        </Suspense>
      </div>
    </div>

    <TripDeparturesConnectionsLink
      v-if="mainTab"
      class="mt-10"
    />

    <b-modal
      v-if="waitinglistModal"
      v-model="waitinglistModal"
      visible
      :hide-footer="true"
      size="lg"
    >
      <template #modal-header>
        <strong data-i18n="waitinglistTitle">
          {{ `${$t('waitinglistTitle')}: ${waitinglistTrip?.tripname ?? ''}` }}
        </strong>
        <div
          v-rtg-tooltip="$t('close')"
          class="modal-close-button"
          data-i18n="close"
          @click="waitinglistModal = false"
          @touchstart="waitinglistModal = false"
        >
          <fa icon="times" />
        </div>
      </template>
      <LazyWaitinglist
        :trip="waitinglistTrip"
        @close="waitinglistModal = false"
      />
    </b-modal>
    <b-modal
      v-if="infoModal"
      v-model="infoModal"
      visible
      body-class="info-modal"
      :hide-header="true"
      :hide-footer="true"
      size="xl"
    >
      <LazyInfoModal
        :trip="infoTrip"
        @close="infoModal = false"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import throttle from 'lodash.throttle'

import '@layers/web/assets/scss/pages/_calendar.scss'
import dayjs from '#build/dayjs.imports.mjs'

const FILTERS = {
  selectedHotel: null,
  selectedTriplength: null,
  hideSoldout: false,
  hideAllNotSingle: false,
  selectedMonth: null,
  overridingHideSoldout: false,
  defaultAirport: null,
}

export default defineNuxtComponent({
  setup () {
    const tableId = useId().replace('-', '_')
    const { defaultAirport: localeDefaultAirport } = useLocale()

    return {
      tableId,
      localeDefaultAirport,
    }
  },

  props: {
    calendar: {
      type: Object,
      default: () => ({ calendar: { departures: [] } }),
    },

    flightTrip: {
      type: Boolean,
      default: false,
    },

    showSeatsLeft: {
      type: Boolean,
      default: true,
    },

    mainTab: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      showRows: 30,
      extraRowsPerScroll: 30,

      filters: { ...FILTERS },

      waitinglistModal: false,
      waitinglistTrip: null,
      infoModal: false,
      infoTrip: null,

      activeDeparturesView: 'table',

      tripList: [],

      loading: true,
    }
  },

  computed: {
    ...mapState(useTripStore, {
      tripInfo: 'trip',
      calendarPage: 'calendarPage',
    }),

    ...mapState(useRootStore, {
      selectedAirport: 'selectedAirportIata',
    }),

    ...mapState(useUserStore, {
      getMemberActiveSingle: 'getMemberActiveSingle',
    }),

    filteroptions () {
      return {
        airports: [],
        hotels: [],
        triplengths: [],
        ...this.calendar.filteroptions,
      }
    },

    airports () {
      return this.filteroptions.airports.reduce(
        (airports, [iata, name, transferIata, transferName]) => {
          if (transferName && transferIata) {
            return [
              ...airports,
              { iata, name, transferIata },
              { iata: transferIata, name: transferName, transferIata: iata },
            ]
          }

          return [
            ...airports,
            { iata, name },
          ]
        },
        []
      )
    },

    hotels () {
      return this.filteroptions.hotels2 || []
    },

    selectedAvailableAirport () {
      if (this.airports.some(({ iata }) => iata === this.selectedAirport)) {
        return this.selectedAirport
      }

      return this.filters.defaultAirport ?? null
    },

    allHotelsAreRecommended () {
      return this.hotels
        .map(({ recommended }) => recommended)
        .filter(x => !x)
        .length === 0
    },

    someHotelsAreRecommended () {
      const r = this.hotels
        .map(({ recommended }) => recommended)
        .filter(Boolean)
      return r.length < this.hotels.length
    },

    triplengths () {
      return this.filteroptions.triplengths
    },

    soldoutTrips () {
      return this.calendar.departures?.filter(d => !d.bookable).length
    },

    tourGuideExists () {
      return this.calendar.departures?.filter(d => !!d.tourleader_name).length > 0
    },

    filteredTrips () {
      if (!this.tripList?.length) {
        return []
      }

      let filteredTrips = (this.tripList || []).filter((t) => {
        let res = true

        if (this.selectedAvailableAirport) {
          res = this.airports
            .filter(({ iata, transferIata }) => [iata, transferIata].includes(this.selectedAvailableAirport))
            .some(({ iata }) => iata.includes(t.transfer_from_airportcode ? t.transfer_from_airportcode : t.airport))
        }

        if (res && this.filters.selectedHotel) {
          res = t.hotel === this.filters.selectedHotel
        }

        if (res && this.filters.selectedTriplength) {
          res = t.triplength === this.filters.selectedTriplength
        }

        return res
      })

      if (this.filters.hideAllNotSingle) {
        const filteredTripsOnlySingleFinder = filteredTrips.filter(t => t.single_finder_list && t.single_finder_list.length > 0)

        if (filteredTripsOnlySingleFinder.length) {
          filteredTrips = filteredTripsOnlySingleFinder
        }
      }

      const filteredTripsWithoutSoldout = filteredTrips.filter(t => !!t.bookable)
      if (filteredTripsWithoutSoldout.length) {
        if (this.filters.overridingHideSoldout) {
          this.filters.overridingHideSoldout = false
        }

        if (this.filters.hideSoldout) {
          filteredTrips = filteredTripsWithoutSoldout
        }
      } else if (!this.filters.overridingHideSoldout) {
        this.filters.overridingHideSoldout = true
      }

      return filteredTrips
    },

    visibleRows () {
      return this.filteredTrips.slice(0, this.showRows)
    },

    filteredTripsForPrint () {
      return this.filteredTrips.slice(0, 25)
    },

    currentHotel () {
      return this.filters.selectedHotel || this.$t('allHotels')
    },

    currentTriplength () {
      return this.filters.selectedTriplength || this.$t('allTriplengths')
    },

    months () {
      const result = {}

      this.tripList.forEach((d) => {
        const date = this.$dayjs(d.date)
        const k = date.format('M/YYYY')
        const m = date.format('MMM YYYY')

        if (!result[k] || parseFloat(d.price) < parseFloat(result[k].price)) {
          result[k] = m
        }
      })

      return Object.keys(result).map(k => result[k]).sort((a, b) => a.ts - b.ts)
    },

    filteredMonths () {
      const result = {}

      this.filteredTrips.forEach((d) => {
        const date = this.$dayjs(d.date)
        const k = date.format('M/YYYY')
        const m = date.format('MMM YYYY')

        if (!result[k] || parseFloat(d.price) < parseFloat(result[k].price)) {
          result[k] = m
        }
      })

      return Object.values(result)
    },

    shouldShowSoldoutFilter () {
      return this.soldoutTrips > 10
    },

    filterCount () {
      let count = 0

      if (this.months?.length > 2) {
        count++
      }
      if (this.shouldShowSoldoutFilter) {
        count++
      }
      if (this.hotels?.length) {
        count++
      }
      if (this.triplengths?.length > 1) {
        count++
      }
      if (this.flightTrip) {
        count++
      }

      return count
    },

    hasActiveFilters () {
      if (this.activeDeparturesView !== 'calendar' && this.selectedAvailableAirport) {
        return true
      }

      const IGNORE_FILTERS = [
        'defaultAirport',
        'hideSoldout',
        'overridingHideSoldout',
        'selectedMonth',
      ]

      return Object.entries(FILTERS)
        .filter(([stateFilterProperty]) => !IGNORE_FILTERS.includes(stateFilterProperty))
        .some(([stateFilterProperty, defaultValue]) => this.filters[stateFilterProperty] !== defaultValue)
    },

    isOverridingAirport () {
      return this.selectedAirport !== this.selectedAvailableAirport
    },

    selectedAvailableAirportName () {
      return this.selectedAvailableAirport
        ? this.findAirportByIata(this.selectedAvailableAirport)?.name
        : null
    },

    dropdownFiltersCount () {
      let dropdownFiltersCount = 0

      if (this.flightTrip) {
        dropdownFiltersCount++
      }
      if (this.triplengths.length > 1) {
        dropdownFiltersCount++
      }
      if (this.hotels.length) {
        dropdownFiltersCount++
      }

      return dropdownFiltersCount
    },
  },

  watch: {
    selectedAirport () {
      this.resetFilters()
    },

    'filters.selectedHotel' () {
      this.resetFilters()
    },

    '$route.params.slug' (v) {
      if (v) {
        this.resetFilters(false)
      }
    },

    '$route.query.hotel': {
      handler (v) {
        if (v) {
          this.filters.selectedHotel = v
        }
      },
      immediate: true,
    },

    'filters.hideSoldout' () {
      this.resetFilters()
      this.generateTripList()
    },

    'filters.hideAllNotSingle' () {
      this.resetFilters()
      this.generateTripList()
    },

    calendar () {
      this.resetFilters()
      this.generateTripList()
    },
  },

  created () {
    this.preSelectAirport()

    if (this.soldoutTrips > 20) {
      this.filters.hideSoldout = true
    }
  },

  mounted () {
    const viewFromQuery = this.$route.query.departures
    if (viewFromQuery) {
      this.changeActiveDeparturesView(viewFromQuery)
    }

    this.page = this.calendarPage

    this.generateTripList()

    this.resizeThrottle = throttle(this.markSelectedMonth, 500)
    window.addEventListener('resize', this.resizeThrottle)
  },

  beforeUnmount () {
    window.removeEventListener('resize', this.resizeThrottle)
  },

  methods: {
    ...mapActions(useRootStore, {
      setGlobalAirport: 'setSelectedAirport',
    }),

    changeActiveDeparturesView (view) {
      this.activeDeparturesView = view
      this.$router.replace({
        query: {
          ...this.$route.query,
          departures: view,
          calendar_page: view === 'table' ? undefined : this.$route.query.calendar_page,
        },
      })

      // Calendar needs to have flight selected to prevent many options per date
      if (this.flightTrip && view === 'calendar' && !this.selectedAvailableAirport) {
        this.filters.defaultAirport = this.airports.some(({ iata }) => iata === this.localeDefaultAirport.airport)
          ? this.localeDefaultAirport.airport
          : this.airports?.[0]?.iata
      } else if (this.filters.defaultAirport) {
        this.filters.defaultAirport = null
      }

      this.filters.selectedMonth = null
    },

    showMoreRows () {
      this.showRows += this.extraRowsPerScroll
    },

    /**
     * Caution! Important function!
     * Incorrect logic will be expensive
     *
     * When a departureid/grouptripid have multiple hotels and or multiple flights from the same airport:
     * Display in table the cheapest and or bookable flight and hotel (cheapest possible trip)
     */
    generateTripList () {
      if (!this.calendar.departures?.length) {
        this.tripList = []
        this.loading = false
        return
      }

      let hotel = ''
      let date = ''
      let group = 0

      // The old way
      const transformed = this.calendar.departures.map((t) => {
        const trip = { ...t }

        if (trip.hotel) {
          if (hotel !== trip.hotel) {
            hotel = trip.hotel
            group = group ? 0 : 1
          }

          trip.group = group

          return t
        }

        if (date !== trip.date) {
          date = trip.date
          group = group ? 0 : 1
        }

        // for odd grouping
        trip.group = !group

        return trip
      })

      if (this.filters.selectedHotel || this.hotels.length <= 1) {
        this.tripList = transformed.sort((a, b) => this.$dayjs(a.date) - this.$dayjs(b.date))
        this.loading = false
        return
      }

      const removeHotelFromTripId = tripid => tripid?.replace(/h[a-z]{0,1}\d+a/, 'ha')
      const extractFlightDepartureIdFromTripId = tripid => tripid.match(/r[0-9]+/)
      const getId = item => item?.airport ? `${extractFlightDepartureIdFromTripId(item.tripid)}_${item.departureid}` : item?.departureid

      const evaluate = (item, list) => {
        const listItem = list?.[getId(item)]

        if (listItem) {
          const listItemIsBookable = !!listItem?.bookable && (listItem?.seats_left || 0) > 0
          const itemIsBookable = !!item?.bookable && (item?.seats_left || 0) > 0
          // bookable, best price

          const bestItem = itemIsBookable && (
            (!listItemIsBookable) ||
            (item.have_double > listItem?.have_double) ||
            (item.have_double === listItem?.have_double && item.price < listItem?.price)
          ) ? item : listItem

          const modifiedBestItem = {
            ...bestItem,
            seats_left: Math.max(bestItem?.seats_left, item?.seats_left),
          }

          return {
            ...modifiedBestItem,
            combined: true,
            tripid: removeHotelFromTripId(bestItem.tripid),
          }
        }

        if (item.stored_search_id) {
          item.tripid = removeHotelFromTripId(item.tripid)
        }

        return item
      }
      const reduced = deepClone(transformed).reduce((list, item) => ({
        ...list,
        [getId(item)]: evaluate(item, list),
      }), {})

      this.tripList = Object.values(reduced)
        .sort((a, b) => this.$dayjs(a.date) - this.$dayjs(b.date))

      this.loading = false
    },

    resetFilters (light = true) {
      this.page = 0
      this.selectMonth(null)

      if (light) {
        return
      }

      this.filters.selectedHotel = null
      this.filters = {
        ...FILTERS,
        hideSoldout: this.filters.hideSoldout,
        defaultAirport: this.filters.defaultAirport,
      }

      if (this.activeDeparturesView !== 'calendar') {
        this.setGlobalAirport(null)
      }
    },

    selectAirport (airport, chokeRefSelectHide = false) {
      this.setGlobalAirport(airport)

      if (!chokeRefSelectHide) {
        // Manually hide here because iOS
        this.$refs.airportSelect?.hide?.()
      }

      this.generateTripList()
    },

    selectHotel (hotel, chokeRefSelectHide = false) {
      this.filters.selectedHotel = hotel

      this.$router.replace({
        query: {
          ...this.$route.query,
          hotel: hotel ?? undefined,
        },
      })

      if (!chokeRefSelectHide) {
        // Manually hide here because iOS
        this.$refs.hotelSelect.hide()
      }

      this.generateTripList()
    },

    openWaitinglist (trip) {
      this.waitinglistModal = true
      this.waitinglistTrip = trip
    },

    openInfo (trip) {
      this.infoModal = true
      this.infoTrip = trip
    },

    markingMonth (monthEndIndex) {
      if (this.showRows <= monthEndIndex) {
        this.showRows = monthEndIndex + 1
      }
    },

    selectMonth (month) {
      if (this.filters.selectedMonth === month) {
        this.filters.selectedMonth = null
      } else {
        this.filters.selectedMonth = month
      }

      if (this.$refs.table) {
        this.$refs.table.selectMonth(this.filters.selectedMonth)
      } else if (month && this.$refs.calendar?.vcalendar) {
        const monthDayjs = dayjs(month, 'MMM YYYY')
        this.$refs.calendar.vcalendar.vcalendar.move({
          month: monthDayjs.month(),
          year: monthDayjs.year(),
        })
      }

      this.markSelectedMonth(true)
    },

    findAirportByIata (searchIata) {
      return (this.airports || []).find(({ iata }) => iata === searchIata)
    },

    preSelectAirport () {
      if (this.flightTrip && this.$route.query.airport) {
        const query = this.$route.query.airport
        const airportFromQuery = this.findAirportByIata(query)

        this.selectAirport(
          airportFromQuery
            ? airportFromQuery.iata
            : null
        )
      }
    },

    markSelectedMonth (shouldScroll) {
      const monthRowIndices = []
      for (let rowIndex = 0; rowIndex < this.filteredTrips.length; rowIndex++) {
        const trip = this.filteredTrips[rowIndex]
        const isSelectedMonth = this.$dayjs(trip.date).format('MMM YYYY') === this.filters.selectedMonth

        if (isSelectedMonth) {
          monthRowIndices.push(rowIndex)
        } else if (monthRowIndices.length) {
          break
        }
      }
      this.$refs.table?.markSelectedMonth(monthRowIndices, shouldScroll)
    },

    monthButtonAttributes (month) {
      const isInTable = this.filteredMonths.includes(month)

      const classes = []

      if (!isInTable) {
        classes.push('opacity-50 pointer-events-none')
      }

      if (month === this.filters.selectedMonth) {
        classes.push('bg-blue-800 text-white')
      } else {
        classes.push('bg-white hover:bg-secondary/75 hover:text-white')
      }

      return {
        disabled: !isInTable,
        class: classes,
      }
    },
  },
})
</script>

<style scoped>
:deep(.dropdown__toggle) {
  height: auto !important;
}
</style>
